/* eslint-disable max-len */
export const API_BASE_URL = '/api/v1' || process.env.API_URL || 'https://designers.mobidev.biz/api/v1';



// WEBPACK FOOTER //
// ./src/config/index.js